import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { BUILD_SHA } from './environments/build-info';

import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeDe);
registerLocaleData(localeFr);

if (environment.glitchtipDsn) {
  Sentry.init({
    dsn: environment.glitchtipDsn,
    environment: environment.production ? 'production' : 'development',
    release: `zugwerk-frontend@${BUILD_SHA}`,
    attachStacktrace: true,
    tracesSampleRate: 0.01,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request?.url) {
        event.request.url = event.request.url.split('?')[0];
      }
      return event;
    },
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
